import axios from 'axios'
import { getToken } from '@/utils/auth'

// One /teacher/center/me request per token; failures resolve to null (menu hidden).
let centerMeRequest = null
let centerMeToken = null
export function fetchCenterMe() {
  const token = getToken()
  if (!token) return Promise.resolve(null)
  if (centerMeRequest && centerMeToken === token) return centerMeRequest
  centerMeToken = token
  centerMeRequest = axios
    .get(`${process.env.VUE_APP_V2_BASE_API}/teacher/center/me`, {
      headers: { Authorization: 'Bearer ' + token },
      timeout: 15000
    })
    .then((res) => res.data || null)
    .catch(() => {
      centerMeRequest = null
      return null
    })
  return centerMeRequest
}

// Center settings: managers, once the platform has granted the module.
export function canOpenCenterSettings(me) {
  return !!me && me.enabled && (me.roles || []).includes('manager')
}
